import { Box, Grid2 as Grid } from "@mui/material";
import { useStyles } from "./PriorityStock.styles";
import { FlagTagProps } from "./types";

export const FlagTag = ({ flagName, icon, skusCount, tagClassName }: FlagTagProps) => {
	const classes = useStyles();
	return (
		<Grid container direction="row" size={12} className={classes.flagTagBox} alignItems="center">
			<Grid size="auto">
				<Box display="flex" alignItems="center" className={tagClassName} sx={{ px: 1, py: 0.3 }}>
					<Box className={classes.flagTagIcon}>{icon}</Box>
					<Box sx={{ whiteSpace: 'nowrap' }}>{flagName} Stock</Box>
				</Box>
			</Grid>
			<Grid size="grow">
				<Box display="flex" justifyContent="flex-end" sx={{ pl: 1 }}>
					<Box>{skusCount} SKUs</Box>
				</Box>
			</Grid>
		</Grid>
	);
};
